import styled from 'styled-components';

export const LinkButton = styled.button`
  background: none;
  border: none;
  color: var(--bs-link-color);
  text-decoration: underline;
  font-weight: inherit;
  cursor: pointer;

  :hover {
    color: var(--bs-link-hover-color) !important;
  }
`;
